import { render, staticRenderFns } from "./WarrantyInfo.vue?vue&type=template&id=563f31d0&scoped=true&"
import script from "./WarrantyInfo.vue?vue&type=script&lang=js&"
export * from "./WarrantyInfo.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyInfo.vue?vue&type=style&index=0&id=563f31d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f31d0",
  null
  
)

export default component.exports